import { ChatFab } from "./ChatFab";
import { ChatWindow } from "./ChatWindow";
import { useChat } from "./ChatProvider";

export function FloatingChat() {
  const { canView, isOpen, toast, dismissToast, openFromToast } = useChat();
  if (!canView) return null;

  return (
    <>
      <ChatFab />
      {isOpen ? <ChatWindow /> : null}
      {toast.open ? (
        <button
          type="button"
          className="chat-toast"
          onClick={openFromToast}
          onKeyDown={(e) => {
            if (e.key === "Escape") dismissToast();
          }}
        >
          <strong>{toast.sender}</strong>
          <span>{toast.content}</span>
          <span
            className="chat-toast__close"
            role="presentation"
            onClick={(e) => {
              e.stopPropagation();
              dismissToast();
            }}
          >
            ×
          </span>
        </button>
      ) : null}
    </>
  );
}
